(function() {
  var article = document.querySelector('.hdt-rte');
  if (!article) return;

  var host = window.location.hostname.toLowerCase();
  var usedProducts = {};
  var currencyMap = {
    'www.wildnord.se': { code: 'SEK', rate: 1, decimals: 0, locale: 'sv-SE', format: '{amount} kr' },
    'wildnord.se': { code: 'SEK', rate: 1, decimals: 0, locale: 'sv-SE', format: '{amount} kr' },
    'www.wildnord.de': { code: 'EUR', rate: 0.091, decimals: 2, locale: 'de-DE', format: '{amount}\u00a0\u20ac', euroRound: true },
    'www.wildnord.fr': { code: 'EUR', rate: 0.091, decimals: 2, locale: 'fr-FR', format: '{amount}\u00a0\u20ac', euroRound: true },
    'www.wildnord.nl': { code: 'EUR', rate: 0.091, decimals: 2, locale: 'nl-NL', format: '\u20ac{amount}', euroRound: true },
    'www.wildnord.it': { code: 'EUR', rate: 0.091, decimals: 2, locale: 'it-IT', format: '{amount}\u00a0\u20ac', euroRound: true },
    'www.wildnord.fi': { code: 'EUR', rate: 0.091, decimals: 2, locale: 'fi-FI', format: '{amount}\u00a0\u20ac', euroRound: true },
    'www.wildnord.dk': { code: 'DKK', rate: 0.679, decimals: 0, locale: 'da-DK', format: '{amount}\u00a0kr' },
    'www.wildnordshop.com': { code: 'USD', rate: 0.104, decimals: 0, locale: 'en-US', format: '${amount}' },
    'ca.wildnordshop.com': { code: 'CAD', rate: 0.148, decimals: 0, locale: 'en-CA', format: 'CA${amount}' },
    'au.wildnordshop.com': { code: 'AUD', rate: 0.149, decimals: 0, locale: 'en-AU', format: 'A${amount}' },
    // wn-strips-uk-es
    'www.wildnord.co.uk': { code: 'GBP', decimals: 0, locale: 'en-GB', format: '£{amount}' },
    'wildnord.co.uk': { code: 'GBP', decimals: 0, locale: 'en-GB', format: '£{amount}' },
    'www.wildnord.es': { code: 'EUR', decimals: 2, locale: 'es-ES', format: '{amount}\u00a0\u20ac' },
    'wildnord.es': { code: 'EUR', decimals: 2, locale: 'es-ES', format: '{amount}\u00a0\u20ac' },
    'www.wildnord.no': { code: 'NOK', decimals: 0, locale: 'nb-NO', format: '{amount}\u00a0kr' },
    'wildnord.no': { code: 'NOK', decimals: 0, locale: 'nb-NO', format: '{amount}\u00a0kr' }
  };

  function parseMarketPrice(raw) {
    if (raw === null || raw === undefined) return null;
    var cleaned = String(raw).replace(/[^0-9,.]/g, '');
    if (!cleaned) return null;

    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');
    if (lastComma !== -1 && lastDot !== -1) {
      cleaned = lastComma > lastDot
        ? cleaned.replace(/\./g, '').replace(',', '.')
        : cleaned.replace(/,/g, '');
    } else if (lastComma !== -1) {
      var commaDecimals = cleaned.length - lastComma - 1;
      cleaned = commaDecimals > 0 && commaDecimals <= 2
        ? cleaned.replace(',', '.')
        : cleaned.replace(/,/g, '');
    } else if (lastDot !== -1) {
      var dotDecimals = cleaned.length - lastDot - 1;
      var dotCount = (cleaned.match(/\./g) || []).length;
      if (dotCount > 1 || dotDecimals === 3) {
        cleaned = cleaned.replace(/\./g, '');
      }
    }

    var amount = parseFloat(cleaned);
    return isNaN(amount) || amount <= 0 ? null : amount;
  }

  function formatMarketPrice(rawPrice) {
    // Shopify's products.json response is already localized for the current market.
    // Converting it again here made Finnish prices 11x too low.
    var amount = parseMarketPrice(rawPrice);
    if (amount === null) return '';

    var config = currencyMap[host];
    if (!config) {
      // Domaine absent de la table : devise active de la vitrine plutôt que le format suédois
      var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      if (active) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: active, maximumFractionDigits: 2 }).format(amount);
        } catch (error) { /* format standard ci-dessous */ }
      }
      config = currencyMap['www.wildnord.se'];
    }
    if (config.decimals === 0) amount = Math.round(amount);

    var formatted = Number(amount).toLocaleString(config.locale, {
      minimumFractionDigits: config.decimals,
      maximumFractionDigits: config.decimals
    });

    return config.format.replace('{amount}', formatted);
  }

  function htmlEscape(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  article.querySelectorAll('a[href*="/collections/"]').forEach(function(link) {
    // Liens placés dans le texte d'un article (attribut data-wn-inline ou URL absolue) : pas d'encadré.
    // Les boutons d'encadré existants utilisent tous une URL relative /collections/...
    if (link.hasAttribute('data-wn-inline') || /^https?:/i.test(link.getAttribute('href') || '')) return;
    var href = link.getAttribute('href');
    var match = href.match(/\/collections\/([\w-]+)/);
    if (!match) return;
    var collection = link.getAttribute('data-wn-collection') || match[1];

    var strip = document.createElement('div');
    strip.className = 'wn-pstrip';

    var parent = link.closest('p') || link.parentNode;
    parent.parentNode.insertBefore(strip, parent);

    fetch('/collections/' + collection + '/products.json?limit=25')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var allProducts = data.products || [];
        if (!allProducts.length) {
          strip.style.display = 'none';
          return;
        }

        for (var i = allProducts.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var temp = allProducts[i];
          allProducts[i] = allProducts[j];
          allProducts[j] = temp;
        }

        var key = collection;
        if (!usedProducts[key]) usedProducts[key] = [];
        var available = allProducts.filter(function(p) {
          return usedProducts[key].indexOf(p.id) === -1;
        });
        if (available.length < 5) available = allProducts;
        var products = available.slice(0, 5);
        products.forEach(function(p) { usedProducts[key].push(p.id); });

        var h = '<div class="wn-pstrip-row">';
        products.forEach(function(p) {
          var img = p.images[0] ? p.images[0].src : '';
          var rawPrice = p.variants[0] ? p.variants[0].price : '';
          var price = formatMarketPrice(rawPrice);
          var title = p.title || '';
          h += '<a href="/products/' + encodeURIComponent(p.handle) + '" class="wn-pstrip-item">';
          h += '<div class="wn-pstrip-imgwrap"><img src="' + htmlEscape(img) + '" alt="' + htmlEscape(title) + '" loading="lazy"></div>';
          h += '<p class="wn-pstrip-title">' + htmlEscape(title.substring(0, 40) + (title.length > 40 ? '...' : '')) + '</p>';
          h += '<p class="wn-pstrip-price" data-source-currency="SEK" data-currency-converted="1">' + htmlEscape(price) + '</p>';
          h += '</a>';
        });
        h += '</div>';
        strip.innerHTML = h;

        var ctaDiv = document.createElement('div');
        ctaDiv.className = 'wn-pstrip-cta';
        ctaDiv.appendChild(link.cloneNode(true));
        strip.appendChild(ctaDiv);

        if (parent.tagName === 'P') {
          parent.style.display = 'none';
        } else {
          link.style.display = 'none';
        }
      }).catch(function(e) {
        console.error(e);
      });
  });
})();
